import { Component, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { ShareButtonsService, DataToShareInterface } from './shareButtons.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'jb-share-buttons-modal',
  templateUrl: './shareButtonsModal.component.html',
  styleUrls: [
    './shareButtonsModal.component.scss'
  ]
})
export class ShareButtonsModalComponent implements OnInit {
  @ViewChild('modalComponentElement')
  public modalComponentElement: ModalComponent;

  private subscriptionShareModalState: Subscription;
  public shareAButton: boolean = false;;
  public socialNetwork: string;
  public shareImageUrl: string;
  public title: string;
  public copy: string;
  public sharingData: DataToShareInterface;

  constructor(private shareButtonsService: ShareButtonsService) { }

  public ngOnInit() {
    this.subscriptionShareModalState = this.shareButtonsService.getShareModalState
      .subscribe(
        (state) => {
          if (state === true) {
            let sharingData = this.shareButtonsService.sharingData;
            this.sharingData = sharingData;

            if (typeof sharingData.shareAButton !== 'undefined') {
              this.shareAButton = sharingData.shareAButton;
            } else {
              this.shareAButton = false;
            }

            this.socialNetwork = sharingData.socialNetwork;
            this.shareImageUrl = sharingData.image;
            this.title = sharingData.title;
            this.copy = sharingData.copy;

            this.openShareModal();
          } else {
            this.closeShareModal();
          }
        }
      );
  }

  public ngOnDestroy() {
    if (typeof this.subscriptionShareModalState !== 'undefined') {
      this.subscriptionShareModalState.unsubscribe();
    }
  }

  private openShareModal() {
    this.modalComponentElement.openModal();
  }

  private closeShareModal() {
    this.modalComponentElement.closeModal();
  }

  public processSharing() {
    this.shareButtonsService.processSharing(this.sharingData);
  }
}



// WEBPACK FOOTER //
// ./src/app/global/shareButtons/shareButtonsModal.component.ts